import { vars } from "@common/styles";
import styled from "styled-components";

export const MetricsGrid = styled.div<{ $rowCount: number }>`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-flow: column;
  grid-template-rows: repeat(${(p) => p.$rowCount}, auto);
  gap: 1.6rem 6.4rem;
  margin-top: 1.2rem;
`;

export const MetricRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const BarsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
`;

export const BarsDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  flex: 0 0 10rem;
  min-width: 0;
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 1.8rem;
    height: 1.8rem;
    color: ${vars.colors.grey60};
    path {
      stroke: ${vars.colors.grey60};
    }
  }
`;

export const MetricLabel = styled.span`
  font-size: 1.3rem;
  color: ${vars.colors.grey50};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 9rem;
`;

export const WarningIconWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
